export default "__VITE_ASSET__B6Gg2Sc2__"